import React from 'react';
import { connect } from 'react-redux';
import Dropzone from 'react-dropzone';

import * as actConfirmAction from 'actions/ingredients/recipes';
import excelLogo from 'assets/images/excel-logo.png';
import { hasFeature } from 'utils/featureFlags';
import styles from './Upload.css';

class Upload extends React.Component {
  // keep intervalId
  intervalId = 0;

  maxLoading = 150;

  constructor() {
    super();
    this.state = {
      files: [],
      isFilled: false,
      currentLoading: 0,
    };
  }

  // remove interval
  componentWillUnmount() {
    clearInterval(this.intervalId);
  }

  // increace the progress bar
  _loadingProgress = () => {
    this.intervalId = setInterval(() => {
      if (this.state.currentLoading === this.maxLoading)
        this.props.dispatch(actConfirmAction.onDropFileCreateRecipes());
      if (this.state.currentLoading <= this.maxLoading) {
        this.setState({ currentLoading: this.state.currentLoading + 10 });
      }
    }, 100);
  };

  _onDrop = acceptedFiles => {
    const reader = new FileReader();
    const csvHeaders = [
      'Recipe_Id(do not edit)',
      'Item_Name',
      'Variant_Name',
      'Ingredient_Name',
      'Ingredient_Unit',
      'Ingredient_Quantity',
    ];
    const increaseImportLimit = hasFeature(
      'increase-import-recipe-feature-flag'
    );
    // there's a bug when upload file
    // expected only csv file could upload, but windows browser can do it.
    // do validation by suffix name file
    if (
      !acceptedFiles.length ||
      acceptedFiles[0].name.substr(
        acceptedFiles[0].name.lastIndexOf('.') + 1
      ) !== 'csv'
    ) {
      this.props.dispatch(
        actConfirmAction.errorValidationUploadCsv('Only .csv files allowed')
      );
      this.props.dispatch(actConfirmAction.nextStepCreateRecipes());
      return;
    }

    reader.readAsText(acceptedFiles[0]);
    reader.onload = event => {
      const csv = event.target.result
        .replace(/\r/g, '\n')
        .replace(/\n\n/g, '\n');
      const dataCsv = this._csvToArray(csv);
      const dataHeadersCsv = dataCsv[0];
      const MAX_ITEM_ROW_PLUS_HEADER = increaseImportLimit ? 10002 : 2502;
      const MAX_ITEM_ROW = increaseImportLimit ? 10000 : 2500;

      // validation headers csv before upload
      const isValidHeaders = csvHeaders.every(
        (el, idx) => el === dataHeadersCsv[idx]
      );
      if (!isValidHeaders) {
        this.props.dispatch(
          actConfirmAction.errorValidationUploadCsv(
            'Invalid format, upload failed. Please use the correct header and csv format from our template and try again'
          )
        );
        this.props.dispatch(actConfirmAction.nextStepCreateRecipes());
      }

      // validation max row before upload
      if (dataCsv.length > MAX_ITEM_ROW_PLUS_HEADER) {
        this.props.dispatch(
          actConfirmAction.errorValidationUploadCsv(
            `The maximum rows for import recipe process is ${MAX_ITEM_ROW} rows.`
          )
        );
        this.props.dispatch(actConfirmAction.nextStepCreateRecipes());
      }
    };

    this.props.dispatch(actConfirmAction.saveFileRecipes(acceptedFiles[0]));
    this.setState({ isFilled: true, files: acceptedFiles });
    this._loadingProgress();
  };

  _csvToArray = csv => {
    return csv.split('\n').map(v => v.split(','));
  };

  // remove file and clear interval
  _handleRemove = () => {
    clearInterval(this.intervalId);
    this.setState({
      files: [],
      isFilled: false,
      currentLoading: 0,
    });
    this.props.dispatch(actConfirmAction.onDropFileCreateRecipes());
  };

  render() {
    return (
      <section>
        <div className={styles.dropzone}>
          <Dropzone
            onDrop={this._onDrop}
            multiple={false}
            accept=".csv"
            className={styles['dropzone-contain']}
            onClick={event => event.stopPropagation()}
            disableClick={this.state.isFilled}
          >
            {this.state.isFilled ? (
              <div className={styles['dropzone-content']}>
                <img
                  src={excelLogo}
                  alt="xls"
                  className={styles['dropzone-image']}
                />
                <div className={styles['container-item']}>
                  <div className={styles['container-name-item']}>
                    <p> {this.state.files[0].name} </p>
                    <p> {(this.state.files[0].size / 1000).toFixed(1)} MB</p>
                  </div>
                  <div className={styles['container-loading']}>
                    {this.state.currentLoading <= this.maxLoading ? (
                      <div className={styles['container-loading-bar']}>
                        <div className={`${styles.progress} progress`}>
                          <div
                            className="progress-bar"
                            style={{ width: `${this.state.currentLoading}%` }}
                          />
                        </div>
                        <span
                          className={`fa fa-times-circle ${
                            styles['icon-close']
                          }`}
                        />
                      </div>
                    ) : (
                      <span
                        className={`fa fa-trash-o ${styles.icon}`}
                        aria-hidden="true"
                        onClick={this._handleRemove}
                      />
                    )}
                  </div>
                </div>
              </div>
            ) : (
              <p className={styles['dropzone-link']}>
                {' '}
                Drag file here or <a> Browse </a>{' '}
              </p>
            )}
          </Dropzone>
        </div>
      </section>
    );
  }
}

function mapStateToProps(state) {
  return {
    ...state.ingredients.recipes,
  };
}

export default connect(mapStateToProps)(Upload);
